import { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { AuthContext } from '../../contexts/Auth'
import ModalMeuPerfil from '../ModalMeuPerfil'
import avatarDefault from '../../assets/img/avatarDefault.png'
import avatarOrganizacaoDefault from '../../assets/img/organizacao.png'
import "./filtroContainer.css"

function FiltroContainer({ children, submit }: any) {

  const navigate = useNavigate()

  const { exibirModalSecundario, modalEstadoSecundario } = useContext(ModalEstadoContext)
  const { isAuth } = useContext(AuthContext)

  const [avatar, setAvatar] = useState('')
  const [avatarOrganizacao, setAvatarOrganizacao] = useState('')
  const [dadosUsuario, setDadosUsuario] = useState(false)
  const [modalPerfil, setModalPerfil] = useState(false)

  const exibirDadosUsuario = () => setDadosUsuario(!dadosUsuario)
  const exibirModalPerfil = () => exibirModalSecundario()

  const sair = () => {

    localStorage.removeItem('usuarioGesttorAvatar')
    localStorage.removeItem('perfilGesttor')
    localStorage.removeItem('usuarioGesttor')
    localStorage.removeItem('organizacaoGesttor')
    localStorage.removeItem('authGesttor')
    localStorage.removeItem('organizacaoGesttorAvatar')
    localStorage.removeItem('modulosOrganizacoes')
    document.cookie = 'authGesttor= ; expires=true, 01 Jan 2023 00:00:01 GMT'
    document.cookie = 'modulosGesttor= ; expires=true, 01 Jan 2023 00:00:01 GMT'

    isAuth()

    return navigate('/')
  }

  useEffect(() => {
    setModalPerfil(modalEstadoSecundario)
  }, [modalEstadoSecundario])

  useEffect(() => {

    const avatar = () => {

      const avatarImg = localStorage.getItem('usuarioGesttorAvatar')

      if (avatarImg === 'null' || avatarImg === null) {

        return setAvatar(avatarDefault)
      }

      return setAvatar(avatarImg)
    }

    avatar()

  }, [])

  useEffect(() => {

    const avatarOrganizacao = () => {

      const avatarOrganizacaoImg = localStorage.getItem('organizacaoGesttorAvatar')

      if (avatarOrganizacaoImg === 'null' || avatarOrganizacaoImg === null) {

        return setAvatarOrganizacao(avatarOrganizacaoDefault)
      }

      return setAvatarOrganizacao(avatarOrganizacaoImg)
    }

    avatarOrganizacao()

  }, [])

  return (

    <section id="fundoContainerFiltrosDefault">
      {modalPerfil && <ModalMeuPerfil />}
      <form className='containerInputsFiltros' onSubmit={submit}>
        {children}
      </form>
      <span id='containerDireitoPesquisa'>
        <img id='avatarUsuarioGesttor' src={avatar} alt='' onClick={exibirDadosUsuario} />
        <img className='avatarOrganizacaoGesttor' src={avatarOrganizacao} alt='' title='Empresa que você está trabalhando atualmente' />
        {dadosUsuario && <span id='dadosUsarioDefaul'>
          <p onClick={() => exibirModalPerfil()}>Meu Perfil</p>
          <p onClick={sair}>Sair</p>
        </span>}
      </span>
    </section>
  )
}

export default FiltroContainer
